var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58701 21.1023C7.90711 21.1023 8.0227 20.8456 7.7882 20.1982L5.78906 13.619L21.1778 4.4895",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94749 15.7527L17.4043 22.0007C18.3694 22.5332 19.0657 22.2574 19.3062 21.1048L22.7485 4.88319C23.1009 3.47023 22.2099 2.82915 21.2866 3.24831L1.07319 11.0425C-0.306548 11.596 -0.298329 12.3658 0.821725 12.7087L6.00895 14.3278L18.0179 6.75152C18.5848 6.40772 19.1053 6.59239 18.6782 6.97151",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8b4afdb1865a03ae5cf03893bb82701c.svg";
export { ForwardRef as ReactComponent };